// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__LAwq7","notes":"Notes_notes__2AHyv"};